namespace TabAurous.Finance {
    export interface ExpenseDetailForm {
        TransDetailsId: Serenity.StringEditor;
        LedgerId: Serenity.LookupEditor;
        Amount: Serenity.DecimalEditor;
        TaxId: Serenity.LookupEditor;
        TaxAmount: Serenity.DecimalEditor;
    }

    export class ExpenseDetailForm extends Serenity.PrefixedContext {
        static formKey = 'Finance.ExpenseDetail';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ExpenseDetailForm.init)  {
                ExpenseDetailForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;
                var w2 = s.DecimalEditor;

                Q.initFormType(ExpenseDetailForm, [
                    'TransDetailsId', w0,
                    'LedgerId', w1,
                    'Amount', w2,
                    'TaxId', w1,
                    'TaxAmount', w2
                ]);
            }
        }
    }
}
